import React from 'react';
import { connect } from 'react-redux';
import { DisclaimerCard } from 'components/DisclaimerCard';
import './InfoPanels.scss';

const InfoPanels = ({ infoButtonActive }) => {
  if (!infoButtonActive) {
    return null;
  }

  return (
    <>
      {/* Lưu ý Panel - Left Side */}
      <div className="info-panel info-panel--left disclaimer-card-container">
        <DisclaimerCard />
      </div>

      {/* Project Info Panel - Right Side */}
      <div className="info-panel info-panel--right">
        <div className="info-panel__table">
          <div className="info-panel__row">
            <div className="info-panel__label">Tên dự án</div>
            <div className="info-panel__value">
              KHU ĐÔ THỊ CAO TẦNG PHỨC HỢP
              <br /> THE WIN CITY
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Tổng quan</div>
            <div className="info-panel__value">
              <p>
                13,1753 HA, 18 block <br />
                hơn 6000 sản phẩm
              </p>
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Mật độ xây dựng</div>
            <div className="info-panel__value">29,82%</div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">
              Diện tích đất y tế,
              <br /> giáo dục
            </div>
            <div className="info-panel__value">
              19.267 M<sup>2</sup>
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Diện tích cây xanh</div>
            <div className="info-panel__value">
              <div>
                26.055 M<sup>2</sup>
              </div>
            </div>
          </div>
          <div className="info-panel__row">
            <div className="info-panel__label">Đơn vị phát triển</div>
            <div className="info-panel__value">
              <div>Tập đoàn BĐS Thắng Lợi</div>
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">
              Liên danh
              <br />
              Chủ Đầu Tư
            </div>
            <div className="info-panel__value">
              Cty CP Thắng Lợi Homes <br /> Cty CP Gỗ An Cường <br /> Cty CP Xây
              dựng Central
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">
              Chủ Đầu Tư
              <br />
              Tổng thầu xây dựng
            </div>
            <div className="info-panel__value">
              <div>Central</div>
            </div>
          </div>
          <div className="info-panel__row">
            <div className="info-panel__label">
              Chủ Đầu Tư
              <br />
              Giải pháp nội thất
            </div>
            <div className="info-panel__value">
              <div>An Cường</div>
            </div>
          </div>
          <div className="info-panel__row">
            <div className="info-panel__label">
              Đơn vị tư vấn <br /> Quản lí vận hành
            </div>
            <div className="info-panel__value">
              <div>CBRE</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  infoButtonActive: state.iconButtons.infoButtonActive,
});

export default connect(mapStateToProps)(InfoPanels);
